import canSetCharmAutomatically from 'owa-calendar-compose-form-store/lib/selectors/canSetCharmAutomatically';
import { checkForKeywords } from 'owa-calendar-charm-suggestions-data';
import { CharmSelectionType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { getNoCharmInfoObject } from 'owa-calendar-charms-store';
import {
    onAutomaticCharmChanged,
    onCharmAndSelectionTypeChanged,
    dismissCharmSuggestions,
} from 'owa-calendar-compose-form-actions';
import { orchestrator } from 'satcheljs';

/**
 * Updates the charm icon and charm selection type when the charm is set automatically from the subject text
 */
export default orchestrator(onAutomaticCharmChanged, actionMessage => {
    if (canSetCharmAutomatically(actionMessage.formId)) {
        const charm = checkForKeywords(actionMessage.subject);
        if (charm) {
            onCharmAndSelectionTypeChanged(
                actionMessage.formId,
                charm,
                CharmSelectionType.Automatic
            );
            dismissCharmSuggestions(actionMessage.formId);
        } else {
            onCharmAndSelectionTypeChanged(
                actionMessage.formId,
                getNoCharmInfoObject(),
                CharmSelectionType.None
            );
        }
    }
});
